import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@/hooks/redux';

export function AuthLayout() {
  const isAuthenticated = useIsAuthenticated();

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-muted/20 relative">
      <div className="absolute inset-0 h-full w-full bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-50" />
      
      <div className="sm:mx-auto sm:w-full sm:max-w-md relative z-10">
        <div className="bg-card py-10 px-6 shadow-2xl sm:rounded-2xl sm:px-12 border border-border/50 backdrop-blur-sm">
          
          {/* Logo and title */}
          <div className="text-center mb-10 flex flex-col items-center">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo.svg" alt="OCCSSG Logo" className="w-10 h-10 invert" />
              <span className="text-3xl font-bold tracking-tight">
                OCCSSG Admin
              </span>
            </div>
            <p className="mt-2 text-sm text-muted-foreground">
              Sign in to manage your portal
            </p>
          </div>

          {/* Auth form content */}
          <Outlet />
          
          {/* Footer */}
          <div className="mt-10 text-center text-xs text-muted-foreground">
            <p>© 2026 OCCSSG. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
}